import React, {useState} from "react";
import Header from "../Header";
import HomeSideNavBar from "../HomeSideNavBar";
import ApiDataProvider from "../ApiDataContext";
import {Bell, HelpCircle, ListChecks, Plus} from "lucide-react";
import TripList from "./TripList";
import CreateTrip from "./CreateTrip";
import NotificationHistory from "./NotificationHistory";
import FleetTripHelpModal from "./FleetTripHelpModal";
import "../../styles/components/tasks.css";
import {hasPermission} from "../../utils/rolePermissions";
import PageHeader from "../../components/layout/PageHeader";
import Tabs from "../../components/ui/Tabs";
import Button from "../../components/ui/Button";
import BackToDashboardButton from "../../components/ui/BackToDashboardButton";

const TAB_LIST   = "TripList";
const TAB_CREATE = "CreateTrip";
const TAB_NOTIF  = "NotificationHistory";

const TAB_META = {
  [TAB_LIST]:   {label: "Fleet Trip List",        subtitle: "Scheduled ignition-on sessions for your tracked fleet."},
  [TAB_CREATE]: {label: "Create / Edit Fleet Trip", subtitle: "Define a multi-stop route with assigned devices."},
  [TAB_NOTIF]:  {label: "Notification History",   subtitle: "Alerts and updates sent during recent trips."},
};

function Trips() {
  const [activeTab, setActiveTab] = useState(TAB_LIST);
  const [editTrip, setEditTrip] = useState(null);
  const [showHelp, setShowHelp] = useState(false);

  const canManage = hasPermission("trips_manage");
  const activeMeta = TAB_META[activeTab] || {label: "Trips", subtitle: ""};

  const handleEditTrip = (trip) => { setEditTrip(trip); setActiveTab(TAB_CREATE); };
  const handleTripSaved = () => { setEditTrip(null); setActiveTab(TAB_LIST); };

  const renderContent = () => {
    switch (activeTab) {
      case TAB_LIST:   return <TripList onEditTrip={handleEditTrip} />;
      case TAB_CREATE: return canManage ? <CreateTrip tripToEdit={editTrip} setTripToEdit={setEditTrip} onSaved={handleTripSaved} /> : null;
      case TAB_NOTIF:  return <NotificationHistory />;
      default:         return null;
    }
  };

  const tabItems = [
    {value: TAB_LIST,   label: "Trip list",   icon: ListChecks},
    canManage && {value: TAB_CREATE, label: "Create / Edit", icon: Plus},
    {value: TAB_NOTIF,  label: "Notifications", icon: Bell},
  ].filter(Boolean);

  return (
    <ApiDataProvider>
      <div className="container">
        <div className="screen-layout">
          <Header />
          <HomeSideNavBar />
          <main className="flex-1 min-w-0 min-h-0 flex flex-col bg-surface-muted overflow-y-auto">
            <PageHeader
              title="Fleet Trips"
              subtitle={activeMeta.subtitle}
              breadcrumbs={[{label: "Trips"}, {label: activeMeta.label}]}
              actions={
                <>
                  <BackToDashboardButton />
                  <Button variant="secondary" icon={HelpCircle} onClick={() => setShowHelp(true)}>
                    Quick guide
                  </Button>
                </>
              }
            />
            <Tabs value={activeTab} onChange={(v) => { if (v === TAB_LIST) setEditTrip(null); if (v === TAB_CREATE) setEditTrip(null); setActiveTab(v); }} items={tabItems} className="bg-white" />
            <div className="flex-1 min-h-0 px-2 sm:px-4 lg:px-6 py-4">
              {renderContent()}
            </div>
            {showHelp && <FleetTripHelpModal onClose={() => setShowHelp(false)} />}
          </main>
        </div>
      </div>
    </ApiDataProvider>
  );
}

export default Trips;
